'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require('../actions/actionTypes');

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var analytics = function analytics(store) {
    return function (next) {
        return function (action) {
            switch (action.type) {
                case actionTypes.LOGIN_SUCCESS:
                    ga('send', 'pageview', '/accounts/login/success/');
                    break;

                case actionTypes.SIGNUP_SUCCESS:
                    ga('send', 'pageview', '/accounts/signup/success/');
                    break;

                case actionTypes.UPGRADE_BILLING_SUCCESS:
                    ga('send', 'pageview', '/accounts/upgrade/success/');
                    break;

                case actionTypes.SET_SEARCH_QUERY:
                    ga('send', 'pageview', '/search/?q=' + action.query);
                    break;

                case actionTypes.REPORT_PLUGIN_USAGE:
                    ga('send', 'event', 'icon', 'placed');
                    break;
            }

            return next(action);
        };
    };
};

exports.default = analytics;